export const hasAccess = (accessConfig) => {
  const loggedInUserRole = JSON.parse(localStorage.getItem("userData"))?.role;
  if (accessConfig.includes(loggedInUserRole)) {
    return true;
  }
  return false;
};
